import { Injectable } from '@angular/core';
import { AppStore } from '@app/app.store';
import { DivisionContext } from '@app/core/services/division/division-context.service';
import { SessionState } from '@app/shared/models/session.interface';
import { User } from '@app/shared/models/user.interface';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  userSubject$: BehaviorSubject<User>;
  constructor(protected jwtService: JwtHelperService, protected appStore: AppStore) {
    this.userSubject$ = new BehaviorSubject<User>(appStore.state.session.user);
  }

  get(): SessionState {
    return this.appStore.state.session;
  }

  getLang(): string {
    return this.get() ? this.get().locale : 'en';
  }

  getToken(): string | null {
    return this.get() ? this.get().token : null;
  }

  getUser(): User | null {
    return this.get() ? this.get().user : null;
  }

  getLocale(): string {
    return this.get() ? this.get().locale : window.navigator.language.split('-')[0];
  }

  getDivisionContext(): DivisionContext {
    return this.get() && this.get().divisionContext ? this.get().divisionContext : { filter: {}, divisions: [] };
  }

  isTokenValid(): boolean {
    return this.getToken() ? !this.jwtService.isTokenExpired(this.getToken()) : true;
  }

  set(session: SessionState): void {
    this.appStore.state = { ...this.appStore.state, session };
    this.appStore.saveState();
    this.userSubject$.next(this.getUser());
  }

  setDivisionContext(divisionContext: DivisionContext): void {
    this.set({ ...this.appStore.state.session, divisionContext });
  }
}
